import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { USER_RECEIVE_RESET_PSWD_URL } from "./Constants.js"

const UserReceiveResetPswd = () => {
	const [status, setStatus] = useState("typing") // typing, submitting, or success
	const [error, setError] = useState(null)
	const [Vcode, setVcode] = useState("")
	const [Email, setEmail] = useState("")
	const [Pswd, setPswd] = useState("")
	const [Min, setMin] = useState("false")
	const [Upper, setUpper] = useState("false")
	const [Lower, setLower] = useState("false")
	const [Numeric, setNumeric] = useState("false")
	const [Special, setSpecial] = useState("false")
	const [Min_color, setMin_color] = useState({ color: "black" })
	const [Upper_color, setUpper_color] = useState({ color: "black" })
	const [Lower_color, setLower_color] = useState({ color: "black" })
	const [Numeric_color, setNumeric_color] = useState({ color: "black" })
	const [Special_color, setSpecial_color] = useState({ color: "black" })
	const navigate = useNavigate()
	let [searchParams, setSearchParams] = useSearchParams()

	useEffect(() => {
		setVcode(searchParams.get("code"))
		setEmail(searchParams.get("email"))
	}, [])

	const handlePswdChange = (e) => {
		let v = e.target.value
		setPswd(v)
		console.log(v)
		if (v.length > 7) {
			setMin(true)
			setMin_color({ color: "green" })
		} else {
			setMin(false)
			setMin_color({ color: "black" })
		}
		if (v.search(/[A-Z]/) !== -1) {
			setUpper(true)
			setUpper_color({ color: "green" })
		} else {
			setUpper(false)
			setUpper_color({ color: "black" })
		}
		if (v.search(/[a-z]/) !== -1) {
			setLower(true)
			setLower_color({ color: "green" })
		} else {
			setLower(false)
			setLower_color({ color: "black" })
		}
		if (v.search(/[0-9]/) !== -1) {
			setNumeric(true)
			setNumeric_color({ color: "green" })
		} else {
			setNumeric(false)
			setNumeric_color({ color: "black" })
		}
		if (v.search(/[!@#$%^&*]/) !== -1) {
			setSpecial(true)
			setSpecial_color({ color: "green" })
		} else {
			setSpecial(false)
			setSpecial_color({ color: "black" })
		}
		setError(null)
	}

	async function handleSubmit(e) {
		e.preventDefault()
		setStatus("submitting")

		try {
			const reset_data = {
				email: Email,
				code: Vcode,
				password: Pswd,
			}
			const { data } = await axios.post(USER_RECEIVE_RESET_PSWD_URL, reset_data)

			setStatus("success")
			navigate("/Login")
		} catch (err) {
			setStatus("typing")
			if (err.message === "Request failed with status code 422") {
				navigate("/login")
			} else {
				setError(
					err.response?.data?.detail || err.message || "An error occurred",
				)
			}
		}

		setTimeout(() => {
			// remove the message line
			setError(null)
		}, 5000)
	}

	return (
		<main className="Main">
			<fieldset className="panel-sm">
				<legend>Reset Password</legend>
				<p>Resetting password for: {Email}</p>
				<form className="InputForm" name="InputForm" onSubmit={handleSubmit}>
					<table id="tbl_box" style={{ border: "none" }}>
						<tbody>
							<tr>
								<td style={{ textAlign: "right", border: "none" }}>
									<label htmlFor="userPswd">New Password:</label>
								</td>
								<td style={{ textAlign: "left", border: "none" }}>
									<input
										id="userPswd"
										type="password"
										autoFocus
										required
										onChange={(e) => handlePswdChange(e)}
										value={Pswd}
									/>
								</td>
							</tr>
						</tbody>
					</table>
					<div className="pswd">
						<p style={Min_color}>Minimum 8 characters</p>
						<p style={Upper_color}>Include Uppercase</p>
						<p style={Lower_color}>Include Lowercase</p>
						<p style={Numeric_color}>Include Numeric</p>
						<p style={Special_color}>Include Special !@#$%^&*</p>
					</div>
					<div className="InputItem" style={{ textAlign: "center" }}>
						<button
							type="submit"
							className="signinBtn"
							style={{ display: "inline-block" }}
							disabled={
								status === "submitting" ||
								Min === false ||
								Upper === false ||
								Lower === false ||
								Numeric === false ||
								Special === false
							}
						>
							Submit
						</button>
						{error && <p id="errMsg">{error}</p>}
					</div>
				</form>
			</fieldset>
		</main>
	)
}

export default UserReceiveResetPswd
